import { colors } from "@/components/Theme/colors";
import { Tag, TagLabel, TagProps } from "@chakra-ui/react";
import { FC } from "react";

interface Props extends TagProps {
  label: string;
}

export const CategoryTag: FC<Props> = ({ label, ...rest }) => (
  <Tag size="sm" bg={colors.neutral[50]} _dark={{ bg: "gray.700" }} {...rest}>
    <TagLabel color={colors.neutral[500]}>{label}</TagLabel>
  </Tag>
);
